const ONE_DAY_MS = 24 * 60 * 60 * 1000;

const startOfDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

export const formatHumanDate = (startISO, locale, t) => {
  const start = new Date(startISO);
  const today = startOfDay(new Date());
  const startDay = startOfDay(start);
  const diffDays = Math.round((startDay - today) / ONE_DAY_MS);

  const time = new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: '2-digit',
  }).format(start);

  if (diffDays === 0) return t('open.preview.date.today', { time });
  if (diffDays === 1) return t('open.preview.date.tomorrow', { time });
  if (diffDays > 1 && diffDays < 7) {
    const weekday = new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(start);
    return t('open.preview.date.thisWeek', { weekday, time });
  }
  const longDate = new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).format(start);
  return t('open.preview.date.full', { date: longDate, time });
};

export const formatCountdown = (startISO, t) => {
  const start = new Date(startISO);
  const today = startOfDay(new Date());
  const startDay = startOfDay(start);
  const diffDays = Math.round((startDay - today) / ONE_DAY_MS);
  if (diffDays < 0) return null;
  if (diffDays === 0) return t('open.preview.countdown.today');
  if (diffDays === 1) return t('open.preview.countdown.tomorrow');
  return t('open.preview.countdown.days', { count: diffDays });
};

export const getCapacity = (game) => {
  if (game.mode === 'FREE') {
    return {
      current: game.currentPlayers || 0,
      total: game.seats || 0,
      unit: 'PLAYERS',
    };
  }
  return {
    current: game.currentTeams || 0,
    total: game.numberOfTeams || 0,
    unit: 'TEAMS',
  };
};

export const formatFomo = (game, t) => {
  const cap = getCapacity(game);
  const remaining = Math.max(cap.total - cap.current, 0);
  const isFull = cap.total > 0 && remaining === 0;

  if (isFull) {
    return { label: t('open.preview.fomo.full'), tone: 'full' };
  }

  const isHot = remaining > 0 && remaining <= (cap.unit === 'PLAYERS' ? 3 : 2);
  const tone = isHot ? 'hot' : 'normal';
  const key =
    cap.unit === 'PLAYERS'
      ? 'open.preview.fomo.missingPlayers'
      : 'open.preview.fomo.missingTeams';
  return {
    label: t(key, { count: remaining, remaining, total: cap.total }),
    tone,
  };
};

export const isGameOver = (status) => status === 'FINALIZED' || status === 'CANCELLED';
